<template>
  <div id="app">
    <component :is="this.$route.meta.layout || layout">
      <template v-slot:layout>
        <router-view 
          :key="$route.fullPath"
          v-slot="{ Component }"
        >
          <component :is="Component" ref="mainContent" />
        </router-view>
      </template>
    </component>
  </div>
</template>

<script>
export default {
  name:'SGV',
  components: {},
  async created() {
    await this.$store.dispatch("fetchImageSettings")
  },
  computed: {
    layout() {
      return this.$currentUser() && this.$currentUser().token ? 'dashboard-layout' : 'authentication-layout';  
    }
  }
  
}
</script>

<style>
.pointer {
  cursor: pointer;
}

.pointer:hover {
  filter: brightness(85%);
};

.pointer:active {
  position: relative;
  top: 1px;
}

.text-end {
  text-align: end;
}
</style>


